<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'" [cardOptionBtn]="true" [cardRouterLink]="'/back-office/dealer-profile/add'" [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
      </app-card>
    </div>
  </div>
</div>
<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Profile'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="profileName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="deleteProfile()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
